import React, {Component} from 'react';
import * as R from 'ramda';
import Plotly from 'plotly.js/dist/plotly';
import classNames from 'classnames';

import {percent} from 'js/common/string_helper';

class InterestsAnalytics extends Component {
    componentDidMount() {
        const interests = this.calculateInterests();
        this.drawInterestsPlotly(interests);
    }

    calculateInterests = () => {
        const {interests} = this.props;
        const interestPercentages = interests.percentages;

        const interestsArr = R.reduce(
            (interestArr, interest) => {
                interestArr.push({
                    name: interest,
                    percentage: interestPercentages[interest]
                });
                return interestArr;
            },
            [],
            R.keys(interestPercentages)
        );

        const topTenInterests = R.pipe(
            R.sort((a, b) => b.percentage - a.percentage),
            R.slice(0, 10),
            R.reverse
        )(interestsArr);

        const interestNameOrdered = R.map(R.prop('name'), topTenInterests);
        const interestPercentageOrdered = R.map(R.prop('percentage'), topTenInterests);

        return {
            interestNameOrdered,
            interestPercentageOrdered
        };
    };

    drawInterestsPlotly = interests => {
        const {elementId, bgColor} = this.props;
        const graphEl = document.getElementById(elementId);
        const {interestNameOrdered, interestPercentageOrdered} = interests;

        const interestNamesFormatted = R.map(
            val => `<b>${val.toUpperCase()}</b>`,
            interestNameOrdered
        );

        const data = [
            {
                type: 'bar',
                orientation: 'h',
                x: interestPercentageOrdered,
                y: interestNamesFormatted,
                marker: {
                    color: Array(interestPercentageOrdered.length).fill('rgb(44, 151, 222)')
                },
                hoverinfo: 'none'
            }
        ];

        const annotationContent = [];
        const graphBgColor = bgColor || '#FFF';

        const layout = {
            autosize: true,
            width: 450,
            height: 300,
            margin: {
                t: 0,
                r: 20,
                b: 0,
                l: 120,
                pad: 10
            },
            annotations: annotationContent,
            xaxis: {
                autorange: true,
                showgrid: false,
                zeroline: false,
                showline: false,
                autotick: true,
                ticks: '',
                showticklabels: false
            },
            yaxis: {
                tickfont: {
                    family: 'Open Sans',
                    size: 12,
                    color: 'black'
                }
            },
            paper_bgcolor: graphBgColor,
            plot_bgcolor: graphBgColor
        };

        for (let i = 0; i < interestNameOrdered.length; i++) {
            annotationContent.push({
                x: interestPercentageOrdered[i],
                y: interestNamesFormatted[i],
                text: `<b>${percent(interestPercentageOrdered[i], 0)}</b>`,
                font: {
                    family: 'Open Sans',
                    size: 12,
                    color: 'rgb(78, 210, 195)',
                    weight: 'bold'
                },
                xanchor: 'left',
                yanchor: 'middle',
                showarrow: false
            });
        }

        Plotly.plot(graphEl, data, layout, {
            displayModeBar: false,
            displaylogo: false
        });
    };

    render() {
        const {elementId, borders, renderForPdf} = this.props;
        const interestsAnalyticsClasses = classNames('interests-analytics', {
            'container-border-top': borders.top,
            'container-border-right': borders.right,
            'container-border-bottom': borders.bottom,
            'container-border-left': borders.left
        });

        return (
            <div className={interestsAnalyticsClasses}>
                <div className="interests-header">TOP 10 INTERESTS</div>
                <div className="interests-graph">
                    <div id={elementId} />
                </div>

                {/*STYLES*/}

                <style>{`
                    .interests-analytics {
                        width: 50%;
                    }

                    .interests-header {
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        padding-bottom: 20px;
                    }

                    .container-border-top {
                        border-top: 1px solid #d4d4d4;
                    }

                    .container-border-right {
                        border-right: 1px solid #d4d4d4;
                    }

                    .container-border-bottom {
                        border-bottom: 1px solid #d4d4d4;
                    }

                    .container-border-left {
                        border-left: 1px solid #d4d4d4;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .interests-analytics {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .interests-graph {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .interests-analytics {
                            display: inline-block;
                            vertical-align: top;
                        }

                        .interests-graph {
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

InterestsAnalytics.propTypes = {};

export default InterestsAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/analytics_shared/interests_analytics.js